// Catálogo de servicios/módulos del sistema de puntos.
// Debe mantenerse alineado con SERVICE_COSTS de serviceConfig.js (backend).
export const POINTS_SERVICES = [
  "psycholaborEvaluations",
  "assessments",
  "comparisons",
  "discTest",
  "reasoningTest",
  "cvFiltering",
  "cvSummary",
  "salesAssessment",
  "interview",
  "interviewQuestions",
  "hunting",
  // Verificación de antecedentes del ATS: 0,5 por consulta (2026-11-01)
  "backgroundCheck",
];
